var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var BaseCollection = require('src/common/base-collection')
var _ = require('lodash')

var ApiKeys = function () {
  // init
  var ApiKey = BaseModel.extend({
    urlRoot: Config.api.host + '/api-keys',
    idAttribute: '_id',
    defaults: {
      enabled: true
    },
    validation: {
      name: {
        required: true
      }
    }
  })

  var ApiKeysCollection = BaseCollection.extend({
    url: Config.api.host + '/api-keys',
    idAttribute: '_id',
    model: ApiKey
    // parse: function (data) {
    //   if (!data.data) return data
    //   return data.data
    // }

  })

  // //
  var API = {
    getApiKeyEntities: function (options) {
      var fetchParams = { reset: true }
      if (options) { if (options.query) fetchParams.data = options.query }

      var apiKeys = new ApiKeysCollection([], options)


      apiKeys.fetch(fetchParams)
      return apiKeys
    },
    getApiKeyEntity: function (id) {
      var apiKey = new ApiKey({_id: id})
      apiKey.fetch()
      return apiKey
    },
    newApiKeyEntity: function () {
      return new ApiKey()
    }
  }

  // Listeners
  App.globalChannel.reply({
    'apikey:entities': API.getApiKeyEntities,
    'apikey:entity': API.getApiKeyEntity
  })

  App.globalChannel.reply('apikey:entity:new', function () {
    return API.newApiKeyEntity()
  })

  // Init
  return API
//
}

module.exports = ApiKeys



// WEBPACK FOOTER //
// ./js/entities/apikeys.js